import { IMonitorWebSocketState } from '../../components/Home';
import {
    MONITOR_WS_CONNECTION_START, MONITOR_WS_CONNECTION_CLOSED, MONITOR_WS_CONNECTION_ERROR, MONITOR_WS_CONNECTION_SUCCESS, MONITOR_WS_GET_MESSAGE,
    TMonitorWsActions, monitorWsConnectionSuccess, monitorWsConnectionError, monitorWsConnectionClosed, monitorWsGetMessage } from '../actions/monitorWsActions';
import { IWsActions } from '../middlewares/wsMiddleware';

export const MONITOR_ENDPOINT: string = 'wss://strategy1.res-media.ru/';

export const wsActionsMonitor: IWsActions = {
    wsInit: MONITOR_WS_CONNECTION_START,
    onOpen: () => monitorWsConnectionSuccess(),
    onClose: (payload: string) => monitorWsConnectionClosed(payload),
    onError: (payload: string) => monitorWsConnectionError(payload),
    onMessage: (payload: string, dispatch?: Function) => monitorWsGetMessage(payload)
};

export const initialState: IMonitorWebSocketState = {
    wsConnected: false,
    error: null,
    payload: null
};

export const monitorWsReducer = (state: IMonitorWebSocketState = initialState, action: TMonitorWsActions): IMonitorWebSocketState => {
    switch (action.type) {
        case MONITOR_WS_CONNECTION_SUCCESS:
            return { ...state, error: null, wsConnected: true };

        case MONITOR_WS_CONNECTION_ERROR:
            return { ...state, error: action.payload, wsConnected: false };

        case MONITOR_WS_CONNECTION_CLOSED:
            return { ...state, error: null, wsConnected: false };

        case MONITOR_WS_GET_MESSAGE: {
            const payload = JSON.parse(action.payload);
            const prevPairsData = state.payload?.pairsData;
            return {
                ...state, error: null,
                payload: {
                    futNearPeriod: payload.futNearPeriod,
                    futFarPeriod: payload.futFarPeriod,
                    pairsData: { ...prevPairsData, ...payload.pairsData }
                }
            };
        }

        default:
            return state;
    }
}; 